import { render, staticRenderFns } from "./ModuleTranslator.vue?vue&type=template&id=7ebf18c1&"
import script from "./ModuleTranslator.vue?vue&type=script&lang=js&"
export * from "./ModuleTranslator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports